import type { RanchSim } from './sim';
import type { Horse, HorseId } from './types';

/**
 * The pedigree is already the data (sireId/damId into the registry);
 * this flattens it for the bracket UI. Generation g holds 2^g slots,
 * sire-line first, null where the record runs out (foundation stock).
 */
export interface PedigreeView {
  subject: Horse;
  /** generations[0] = [sire, dam], [1] = 4 grandparents, [2] = 8. */
  generations: (Horse | null)[][];
}

export function pedigreeOf(sim: RanchSim, horseId: HorseId, depth = 3): PedigreeView | null {
  const subject = sim.horseById(horseId);
  if (!subject) return null;
  const generations: (Horse | null)[][] = [];
  let current: (Horse | null)[] = [subject];
  for (let generation = 0; generation < depth; generation += 1) {
    const next: (Horse | null)[] = [];
    for (const horse of current) {
      next.push(horse?.sireId != null ? sim.horseById(horse.sireId) : null);
      next.push(horse?.damId != null ? sim.horseById(horse.damId) : null);
    }
    generations.push(next);
    current = next;
  }
  return { subject, generations };
}
